<template>
  <div id="signup">
    <Navbar></Navbar>
    <div class="container">
      <h1>Sign Up</h1>
      <p>
        In order to create an account, request access to the
        <router-link to="beta">beta</router-link>
      </p>
      <input type="email" placeholder="Email" v-model="email" readonly />
      <br />
      <input type="password" placeholder="Password" v-model="password" readonly />
      <br />
      <button disabled @click="signUp">Sign Up</button>
      <p>
        Have an account?
        <router-link to="/login">Login</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Navbar from "../components/Navbar";
import { db } from "../main";
export default {
  name: "SignUp",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    signUp: function () {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          // eslint-disable-next-line
          (usr) => {
            let currUser = firebase.auth().currentUser;
            db.collection("users")
              .doc(currUser.uid)
              .set({
                email: this.email,
              })
              .then(() => {
                this.$router.push("dashboard");
              });
          },
          (err) => {
            alert("Error: " + err);
          }
        );
    },
  },
  firestore() {
    return {
      random: db.collection("random"),
    };
  },
  components: {
    Navbar,
  },
};
</script>

<style lang="scss" scoped>
#signup {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0cce6b;
  color: #f7f9fb;
}

.container {
  input {
    padding: 5px 5px;
    font-size: 1.1rem;
    margin: 15px 0;
    background: transparent;
    border: none;
    border-bottom: solid white;
    outline: none;
    color: white;
    width: 300px;
  }

  a {
    text-decoration: none;
    color: #ef2d56;
    font-weight: 600;
  }

  button {
    margin: 15px 0;
    padding: 10px 10px;
    width: 60%;
    border: none;
    outline: none;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 50px;
    transition: 0.15s;
    // &:hover {
    //   cursor: pointer;
    //   color: #ffffff;
    //   background: #ef2d56;
    // }
  }
}
</style>